import { DeployEnv } from '@patsnap-utils/biz';
import { REGION } from '@eureka/utils/environment';
import type { EditionType, PlanConfig } from '../types';

export const isSandBoxEnv = [DeployEnv.CI, DeployEnv.QA, DeployEnv.STAGE, DeployEnv.DEV].includes(REGION)
export const isOversea = [DeployEnv.US, DeployEnv.EU].includes(REGION)
export const isUS = REGION === DeployEnv.US;
export const isEU = REGION === DeployEnv.EU;

/**
 * 套餐价格表
 */
export const PRICE_MAP: Record<EditionType, { priceId: string, billingCycle: 'monthly' | 'yearly' }[]> = {
    basic: [],
    rd_pro: [
        {
            priceId: isUS ? 'price_1TBVWv3n4XHnBaSm1uMi3KHJ' : (isEU ? 'price_1T9KeB3n4XHnBaSmdjvsMuED' : 'price_1SzTRt4BHjfY2tko9hRTn6lm'),
            billingCycle: 'monthly',
        },
        {
            priceId: isUS ? 'price_1SzTsn3n4XHnBaSmadDrjQtL' : (isEU ? 'price_1T9KeW3n4XHnBaSm6iE26PEd' : 'price_1SzTSA4BHjfY2tkodoZEejax'),
            billingCycle: 'yearly',
        }
    ],
    enterprise: [],
    api: [],
}

export const PLAN_CONFIG_MAP: Record<EditionType, PlanConfig> = {
    basic: {
        credits: 10,
        originalPrice: 0,
        salePrice: 0,
    },
    rd_pro: {
        credits: 100,
        originalPrice: 398,
        salePrice: 100,
        yearlyOriginalPrice: 1200, // 100 * 12
        yearlySalePrice: 1080, // 90 * 12 (相当于优惠120)
        emergencyPackOriginalPrice: 25,
        emergencyPackSaleDiscount: 20,
        emergencyPackSalePrice: 20,
        projectPackOriginalPrice: 55,
        projectPackSalePrice: 44,
        projectPackSaleDiscount: 20,
    },
    enterprise: {
        credits: 100,
        originalPrice: 398,
        salePrice: 99,
        yearlyOriginalPrice: 4776, // 398 * 12
        yearlySalePrice: 199, // 199 * 10 (相当于优惠2个月)
        emergencyPackOriginalPrice: 25,
        emergencyPackSaleDiscount: 20,
        emergencyPackSalePrice: 20,
        projectPackOriginalPrice: 55,
        projectPackSalePrice: 44,
        projectPackSaleDiscount: 20,
    },
    api: {
        credits: 100,
        originalPrice: 398,
        salePrice: 99,
        yearlyOriginalPrice: 4776, // 398 * 12
        yearlySalePrice: 199, // 199 * 10 (相当于优惠2个月)
        emergencyPackOriginalPrice: 25,
        emergencyPackSaleDiscount: 20,
        emergencyPackSalePrice: 20,
        projectPackOriginalPrice: 55,
        projectPackSalePrice: 44,
        projectPackSaleDiscount: 20,
    },
}
